import React from 'react';
import DataTable from '@preflighttech/preflight-tables';
import moment from 'moment';

import minimalTable from 'app/src/elements/minimalTable';
import { Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';
import { dollars } from 'app/src/utils/stringHelpers';

const PreBidsDetail = ({ saleAsset }) => {
  const columns = [
    {
      key: 'highBid',
      label: 'Current High Bid',
      value: ({ entry }) => (
        entry.id === saleAsset.highPreBid.id ? saleAsset.highPreBidPrice : null
      ),
      content: ({ value }) => (
        value ? <Text style={{ fontWeight: 600 }}>{dollars(value)}</Text> : ''
      )
    },
    {
      key: 'type',
      label: 'Type',
      value: ({ value }) => 'Normal' === value ? 'Pre-Bid' : 'Max Bid',
    },
    {
      key: 'price',
      label: 'Price',
      content: ({ value }) => dollars(value)
    },
    {
      key: 'buyer',
      label: 'Buyer',
      width: 200,
      value: ({ entry }) => entry.buyerUser?.buyer.name,
      content: ({ value, entry }) => (
        value ? (
          <Link to={`/buyers/${entry.buyerUser.buyer.id}`}>
            <Text>{value}</Text>
          </Link>
        ) : null
      )
    },
    {
      key: 'paddleNumer',
      label: 'Paddle #',
      value: ({ entry }) => entry.buyerUser?.paddleNumber
    },
    {
      key: 'createdAt',
      label: 'Entered Time',
      width: 160,
      value: ({ entry }) => entry.createdAt,
      content: ({ value }) => moment(value).format('MM-DD-YY \@ hh:mmA'),
    },
  ];

  return (
    <DataTable.Simple
      data={saleAsset.preBids}
      columns={columns}
      component={minimalTable}
      pageLength="All"
      htmlTable
    />
  );
};

export default PreBidsDetail;
